import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../../_metronic/helpers' // Response might not be needed if we define specific response types
import {SupplierDeliveryItem, SupplierDeliveryRecordApiResponse} from './SupplierDeliveryRecordModel'
import {API_URL} from '../../../tenant/apiBase'

const SUPPLIER_DELIVERY_ENDPOINT = `${API_URL}/api/partner-portal/supplier-delivery-record-to-dumyah`

export const getSupplierDeliveryRecords = (
  filtersObj: string | undefined, // Changed from query to filtersObj for consistency
  token: string | undefined,
  language: string
): Promise<SupplierDeliveryRecordApiResponse> => { // Return type remains the same for now, can be refined
  // Construct query parameters similar to reports _requests.ts
  const queryParams = filtersObj ? `${filtersObj}${filtersObj.startsWith('?') ? '' : '&'}` : '';
  // If filtersObj already starts with '?', don't add another. If it's not empty and doesn't start with '?', prefix with '?'.
  // A simpler approach if filtersObj is expected to be a ready-to-use query string (e.g. "page=2&limit=10")
  // is just to append it if it exists. The reports file seems to build it more dynamically.
  // For now, let's assume filtersObj is a string like "key=value&key2=value2" or empty.
  const fullQuery = filtersObj ? `?${filtersObj}` : '';


  return axios.get<SupplierDeliveryRecordApiResponse>( // Directly expect SupplierDeliveryRecordApiResponse
    `${SUPPLIER_DELIVERY_ENDPOINT}${fullQuery}`,
    {
      headers: {
        token: token || '', // Use 'token' header key
        language: language, // Use 'language' header key, consistent with reports
      },
    }
  ).then((response: AxiosResponse<SupplierDeliveryRecordApiResponse>) => response.data); 

}

